import React, { Component } from 'react'
import { connect } from 'react-redux'

import { message } from 'antd'

class Messages extends Component {
  componentDidUpdate = () => {
    const { messages } = this.props

    messages.error && message.error(messages.error)
    messages.warning && message.warning(messages.warning)
    messages.success && message.success(messages.success)
    // cleanMessages() - can't be here; after dispatch of asyncFail should be called clean
  }
  render () {
    return <div />
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  messages: state.messages
})

export default connect(mapStateToProps)(Messages)



// WEBPACK FOOTER //
// ./src/components/Messages.js